module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/EARTH_ELEMENTAL_STYLE.58c9539b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/EARTH_ELEMENTAL_STYLE.png
// module id = 1151
// module chunks = 16